import type { TranslationKey } from '$lib/server/translations/translations.service';

export interface Config {
	PublicToken: string;
	Env: string;
	Culture: string;
	ErrorCode?: string;
	Ipn?: number | string;
}

export enum EnvType {
	dev = 'dev',
	dev1 = 'dev1',
	dev2 = 'dev2',
	dev3 = 'dev3',
	dev4 = 'dev4',
	stg = 'stg',
	beta = 'beta',
	sandbox = 'sandbox',
	production = 'production',
	local = 'local'
}

export interface ILearnMoreData {
	Installments: IInstallment[];
	NumberOfInstallments: number;
	ResponseHeader: { Succeeded: boolean; Errors: any; TraceId: string };
	ShowNonSecureStrategyInfo: boolean;
	ShowSecureStrategyInfo: boolean;
	SupportsCreditCard: boolean;
	SupportsDebitCard: boolean;
	Total: { Value: number; CurrencyCode: string };
	CurrencySymbol?: string;
	PlanStrategy: string;
	Error?: any;
	url: string;
	traceId: string;
}

export interface IInstallment {
	Amount: Amount;
	Date: Date;
	HeldAmount: number;
}

export interface Amount {
	Value: number;
	CurrencyCode: string;
}

export interface IPlanBoxInfo {
	iconType: string;
	incomingLineType: string;
	outgoingLineType: string;
	amount: string;
	date: string;
	isWide: boolean;
	held?: string;
}

export interface ILearnMoreQueryParams {
	publicToken?: string;
	apiKey?: string;
	numInstallments?: string;
	totalNumInstallments?: string[];
	amount?: string;
	currencyCode?: string;
	culture: string;
	ipn?: string;
	docType?: string;
}

export interface Schedule {
	Installments: Installment[];
	NumberOfInstallments: number;
	ResponseHeader?: {
		Succeeded: boolean;
		Errors: any;
		TraceId: string;
	};
	ShowNonSecureStrategyInfo?: boolean;
	ShowSecureStrategyInfo?: boolean;
	SupportsCreditCard?: boolean;
	SupportsDebitCard?: boolean;
	Total: Amount;
}

export interface Installment {
	Amount: Amount;
	Date: string;
	HeldAmount: number;
}

export interface Amount {
	Value: number;
	CurrencyCode: string;
}

export interface InstallmentIndexed extends Installment {
	NumberOfInstallment: number;
}

export interface LearnData {
	isPre: boolean;
	amount: number;
	currencySymbol: string;
	learnData: Schedule[];
	availableCredit: number;
	strategy: number;
	isWhiteLabel: boolean;
	isFortnightly: boolean;
	selectedInstallment?: Schedule;
	culture?: string;
}

export enum PlanStrategy {
	STRATEGY_3 = 3,
	STRATEGY_4 = 4,
	STRATEGY_NON = 0
}

export interface LearnMoreItem {
	title: TranslationKey;
	subtitle: TranslationKey;
	icon: string;
}

export enum Strategy {
	SecuredPlan4A = 'SecuredPlan4A',
	SecuredPlan3 = 'SecuredPlan3',
	SecuredPlan3A = 'SecuredPlan3A',
	SecuredPlan4 = 'SecuredPlan4',
	NonSecuredPlan = 'NonSecuredPlan',
	SecuredPlan = 'SecuredPlan',
	SecuredPlan3B = 'SecuredPlan3B',
	SecuredPlan4B = 'SecuredPlan4B'
}
